import { showToastNotification } from 'welltrax-ui-components';
import { findIndex, pull, uniqBy } from 'lodash';
import { action, computed, observable } from 'mobx';
import { InjectedIntl } from 'react-intl';

import { intl } from '../utils/Intl';

export class ParentStore {
  @observable
  public element: any;

  @observable
  public elements: any[];

  @observable
  public selectedElements: any[];

  @observable
  public isLoading: boolean;

  public serviceContainer: any;
  /**
   * @deprecated use the global function intl() from core/utils/Intl
   * @description for internationalization
   */
  public intl: InjectedIntl;

  constructor(serviceContainer: any) {
    this.serviceContainer = serviceContainer;
    this.element = {};
    this.elements = [];
    this.selectedElements = [];
    this.isLoading = false;
    this.intl = {} as any;
  }

  @action
  public setLoading(value: boolean) {
    this.isLoading = value;
  }

  @action
  public setElement(element: any) {
    this.element = element;
  }

  @action
  public setIntl(intl: InjectedIntl) {
    this.intl = intl;
  }

  @action
  public resetElement() {
    this.element = {};
  }

  @action
  public setElements(elements: any[]) {
    this.elements = elements;
  }

  @action
  public setSelectedElements(item: any[]) {
    this.selectedElements = uniqBy(item, 'id');
  }

  @action
  public resetSelectedElements() {
    this.selectedElements = [];
  }

  @action
  public pushSelectedElements(item: any) {
    if (findIndex(this.selectedElements, { id: item.id }) === -1) {
      this.selectedElements.push(item);
    }
  }

  @action
  public pullSelectedElements(item: any) {
    this.selectedElements = pull(this.selectedElements, item);
  }

  @action
  public createStore() {
    this.element = {};
    this.elements = [];
    this.selectedElements = [];
    this.isLoading = true;
  }

  @computed
  get haveSelectedElement() {
    return !!this.selectedElements.length;
  }

  @computed
  get canNotBeAssigned() {
    return this.selectedElements.length > 1;
  }

  public getElements(params?: any) {
    this.setLoading(true);
    this.serviceContainer
      .getAll(params)
      .then((response: any) => {
        this.setElements(response.data);
        this.resetSelectedElements();
        this.setLoading(false);
      })
      .catch((err: any) => {
        this.setLoading(false);
        throw err.response;
      });
  }

  public updateElement() {
    const item = this.element;
    this.setLoading(true);
    this.serviceContainer
      .update(item)
      .then(() => {
        this.getElements();
        this.resetElement();
        this.resetSelectedElements();
        this.setLoading(false);
      })
      .catch((err: any) => {
        this.setLoading(false);
        throw err.response;
      });
  }

  public deleteElement() {
    const itemId = this.element.id;
    this.setLoading(true);
    this.serviceContainer
      .delete(itemId)
      .then(() => {
        this.getElements();
        this.resetElement();
        this.resetSelectedElements();
        this.setLoading(false);
      })
      .catch((err: any) => {
        this.setLoading(false);
        throw err.response;
      });
  }

  public deleteElementById(itemId: number) {
    this.setLoading(true);
    this.serviceContainer
      .delete(itemId)
      .then(() => {
        this.getElements();
        this.resetElement();
        this.resetSelectedElements();
        this.setLoading(false);
      })
      .catch((err: any) => {
        this.setLoading(false);
        throw err.response;
      });
  }

  public deleteElements() {
    this.setLoading(true);
    const promiseArray: any[] = [];
    for (const element of this.selectedElements) {
      promiseArray.push(this.serviceContainer.delete(element.id));
    }
    Promise.all(promiseArray).then((response: any) => {
      this.getElements();
      this.resetElement();
      this.resetSelectedElements();
      this.setLoading(false);
    });
  }

  public createElement() {
    const item = this.element;
    this.setLoading(true);
    this.serviceContainer
      .create(item)
      .then(() => {
        this.getElements();
        this.resetElement();
        this.resetSelectedElements();
        this.setLoading(false);
      })
      .catch((err: any) => {
        this.setLoading(false);
        throw (err as Error).message;
      });
  }

  public showSuccessMessage = (message?: string) => {
    showToastNotification({
      message: message || `${intl('app.successMessage', 'Successfully Saved')}`,
      type: 'success'
    });
  };

  public showFormErrorMessage = (message?: string) => {
    showToastNotification({
      message: message || `${intl('app.formError', 'There are Errors In The Form')}`,
      type: 'danger'
    });
  };
}
